import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import { compose } from 'recompose'
import Dropzone from 'react-dropzone'
import { Flex, Box } from 'reflexbox'
import FontIcon from 'react-toolbox/lib/font_icon'

import Button from './Button'

import styles from './styles.scss'
import style from './styles.js'

const FulcrumDropzone = (props) => {
  const {
    maxSize,
    multiple,
    onDropRejected,
    onDropAccepted,
    accept
  } = props

  return (
    <Dropzone
      style={style.default}
      multiple={multiple}
      maxSize={maxSize}
      onDropAccepted={onDropAccepted}
      onDropRejected={onDropRejected}
      accept={accept}
    >
      <Flex
        align='center'
        column
        auto
        styleName='dropzoneContainer'
      >
        <FontIcon
          styleName='uploadIcon'
          value='cloud_upload'
        />
        <div styleName='dragContainer'>
          <span styleName='dragText'>DRAG</span>
          &
          <span styleName='dropText'>DROP</span>
        </div>
        <div styleName='uploadContainer'>
          <span>TO UPLOAD</span>
        </div>
        <Box auto/>
        <div styleName='buttonContainer'>
          <Button label='or, select file'/>
        </div>
      </Flex>
    </Dropzone>
  )
}

FulcrumDropzone.propTypes = {
  multiple: PropTypes.bool.isRequired,
  onDropAccepted: PropTypes.func,
  onDropRejected: PropTypes.func,
  maxSize: PropTypes.number.isRequired,
}

FulcrumDropzone.defaultProps = {
  multiple: false,
  maxSize: 50000000 // 50MB
}

const withStyle = CSSModules(styles)
const enhance = compose(
  withStyle
)

export default enhance(FulcrumDropzone)
